module.exports = __webpack_public_path__ + "static/media/menu_userProfileApproval_hoverActive.99c8141c.svg";